import _ from 'lodash';

export default _.memoize(
    function (answerState, condition) {
        return _(condition).find(condition => {
            // both arrays are mapped to strings to prevent issues with data types
            let value = (answerState[condition.formquestion_id] || []).map(v => v.toString()),
                conditionValues = condition?.values?.map(v => v.toString()) ?? [];

            switch (condition.operator) {
                case 'equals':
                    // console.log('checkCondition EQUAL op ', value, conditionValues, _.intersection(value, conditionValues));
                    return value.length == conditionValues.length && _.intersection(value, conditionValues).length == conditionValues.length;
                case 'contains':
                    return _.intersection(value, conditionValues).length == conditionValues.length;
                case 'hasAnswer':
                    return !!value.length;
                default:
                    console.error('Unsupported operator: ', condition);
            }
        });
        // }
    },
    function (answerState, condition) {
        return JSON.stringify([answerState, condition]);
    }
);
